import { useState } from 'react';
import api from '../api/client';

const ICONS = {
  telegram: 'fa-brands fa-telegram',
  vk: 'fa-brands fa-vk',
  max: 'fa-solid fa-comment',
};

function MessengerOpenLink({ messenger }) {
  const icon = ICONS[messenger.type] || 'fa-solid fa-comments';
  return (
    <a
      className="student-messenger-open"
      href={messenger.url}
      target="_blank"
      rel="noopener noreferrer"
      onClick={(e) => e.stopPropagation()}
      title={messenger.url}
    >
      <i className={icon} aria-hidden />
      {messenger.label}
    </a>
  );
}

/**
 * Ссылка на переписку (Макс / ВК) и правка URL преподавателем.
 */
export default function StudentMessengerCell({ studentId, messenger, onUpdated }) {
  const [editing, setEditing] = useState(false);
  const [draft, setDraft] = useState('');
  const [saving, setSaving] = useState(false);
  const [error, setError] = useState('');

  function startEdit(e) {
    e.stopPropagation();
    setDraft(messenger?.source === 'relation' ? messenger.url : '');
    setError('');
    setEditing(true);
  }

  function cancel(e) {
    e.stopPropagation();
    setEditing(false);
    setError('');
  }

  async function save(e) {
    e.preventDefault();
    e.stopPropagation();
    setSaving(true);
    setError('');
    try {
      const res = await api.patch(`/teacher/students/${studentId}/messenger/`, {
        messenger_url: draft.trim(),
      });
      onUpdated?.(res.data.messenger ?? null);
      setEditing(false);
    } catch (err) {
      const msg = err.response?.data?.messenger_url;
      setError(Array.isArray(msg) ? msg[0] : (typeof msg === 'string' ? msg : 'Не удалось сохранить ссылку.'));
    } finally {
      setSaving(false);
    }
  }

  if (editing) {
    return (
      <form className="student-messenger-edit" onClick={(e) => e.stopPropagation()} onSubmit={save}>
        <input
          type="text"
          className="form-input"
          autoFocus
          value={draft}
          onChange={(e) => setDraft(e.target.value)}
          placeholder="https://max.ru/u/… или vk.com/im?sel=…"
          aria-label="Ссылка на переписку"
        />
        {error && <div className="student-messenger-error">{error}</div>}
        <div className="student-messenger-edit-actions">
          <button type="submit" className="btn btn-xs btn-primary" disabled={saving}>
            {saving ? '…' : 'Сохранить'}
          </button>
          <button type="button" className="btn btn-xs btn-outline" onClick={cancel} disabled={saving}>
            Отмена
          </button>
        </div>
      </form>
    );
  }

  return (
    <div className="student-messenger" onClick={(e) => e.stopPropagation()}>
      {messenger?.url ? (
        <MessengerOpenLink messenger={messenger} />
      ) : (
        <span className="text-secondary student-messenger-empty">нет ссылки</span>
      )}
      <button
        type="button"
        className="btn btn-xs btn-outline student-messenger-edit-btn"
        onClick={startEdit}
        title="Изменить ссылку на чат"
        aria-label="Изменить ссылку на чат"
      >
        <i className="fa-solid fa-pencil" aria-hidden />
      </button>
    </div>
  );
}
